'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _map2 = _interopRequireDefault(require("lodash/map"));

var _take2 = _interopRequireDefault(require("lodash/take"));

var _drop2 = _interopRequireDefault(require("lodash/drop"));

var _pick2 = _interopRequireDefault(require("lodash/pick"));

var _isFunction2 = _interopRequireDefault(require("lodash/isFunction"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

var _classnames = _interopRequireDefault(require("classnames"));

var _sort_direction = _interopRequireDefault(require("./sort_direction"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var defaultHeaderCellRenderer = function defaultHeaderCellRenderer(_ref) {
  var label = _ref.label,
      dataKey = _ref.dataKey;
  return label;
};

var Header =
/*#__PURE__*/
function (_Component) {
  _inherits(Header, _Component);

  function Header() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, Header);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Header)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "onColumnClick", function (column) {
      if (!column.sortable) {
        return;
      }

      var newSortKey = column.dataKey; // Reverse sorting if same column is clicked else sort descending

      _this.props.onSort({
        sortBy: newSortKey,
        sortDirection: _this.props.sortDirection === _sort_direction["default"].ASC ? _sort_direction["default"].DESC : _sort_direction["default"].ASC
      });
    });

    _defineProperty(_assertThisInitialized(_this), "renderColumn", function (columnComponent, _ref2) {
      var leftScroller = _ref2.leftScroller,
          rightScroller = _ref2.rightScroller;
      var _this$props = _this.props,
          sortBy = _this$props.sortBy,
          sortDirection = _this$props.sortDirection;
      var column = columnComponent.props;
      var isSorting = sortBy === column.dataKey;
      var className = (0, _classnames["default"])('table-column-header', column.dataKey, column.className, {
        sorting: isSorting,
        'sorting-asc': sortDirection === _sort_direction["default"].ASC,
        sortable: column.sortable,
        'has-scroll-button': leftScroller || rightScroller
      }).replace('.', '-');
      var headerCellRenderer = (0, _isFunction2["default"])(column.headerCellRenderer) ? column.headerCellRenderer : defaultHeaderCellRenderer;
      return _react["default"].createElement("div", {
        className: className,
        key: column.dataKey
      }, _react["default"].createElement("span", {
        className: "table-column-text",
        onClick: function onClick() {
          return _this.onColumnClick(column);
        }
      }, _react["default"].createElement("span", {
        title: column.label
      }, headerCellRenderer((0, _pick2["default"])(column, ['label', 'dataKey'])), isSorting && _react["default"].createElement("span", {
        className: "sorting-icon"
      }))), rightScroller && _this.renderScroller('right', _this.props.onScrollRight), leftScroller && _this.renderScroller('left', _this.props.onScrollLeft));
    });

    return _this;
  }

  _createClass(Header, [{
    key: "renderScroller",
    value: function renderScroller() {
      var direction = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'right';
      var callback = arguments.length > 1 ? arguments[1] : undefined;
      return _react["default"].createElement("div", {
        className: "column-scroller icon-arrow-".concat(direction),
        onClick: callback
      });
    }
  }, {
    key: "renderLoadingColumn",
    value: function renderLoadingColumn(columnComponent, _) {
      var column = columnComponent.props;
      var className = (0, _classnames["default"])('table-column-header', column.dataKey, 'loading', column.className);
      return _react["default"].createElement("div", {
        className: className,
        key: column.dataKey
      });
    }
  }, {
    key: "renderColumns",
    value: function renderColumns(columnRenderer) {
      var _this$props2 = this.props,
          columns = _this$props2.columns,
          scrolledColumns = _this$props2.scrolledColumns,
          maxVisibleColumns = _this$props2.maxVisibleColumns,
          minVisibleColumns = _this$props2.minVisibleColumns;
      var numVisibleColumns = maxVisibleColumns ? maxVisibleColumns : columns.length;
      var canScrollRight = scrolledColumns + maxVisibleColumns + minVisibleColumns < columns.length;
      var canScrollLeft = scrolledColumns > 0;

      if (columns.length === 0) {
        return _react["default"].createElement("div", {
          className: "table-column-header"
        }, _react["default"].createElement("span", {
          className: "table-column-text"
        }, "Missing columns"));
      }

      var ret = (0, _drop2["default"])(columns, scrolledColumns + minVisibleColumns);
      ret = (0, _take2["default"])(ret, numVisibleColumns);
      ret = (0, _map2["default"])(ret, function (column, index) {
        return columnRenderer(column, {
          rightScroller: index === numVisibleColumns - minVisibleColumns && canScrollRight
        });
      });
      ret.unshift(columns.length > 0 ? columnRenderer(columns[0], {
        leftScroller: scrolledColumns > 0
      }) : _react["default"].createElement("div", null, "No columns specified"));
      return ret;
    }
  }, {
    key: "render",
    value: function render() {
      return _react["default"].createElement("div", {
        className: (0, _classnames["default"])(this.props.className, {
          'loading': this.props.loading
        }),
        style: _objectSpread({}, this.props.style, {
          height: this.props.height
        })
      }, this.props.loading ? this.renderColumns(this.renderLoadingColumn) : this.renderColumns(this.renderColumn));
    }
  }]);

  return Header;
}(_react.Component);

_defineProperty(Header, "propTypes", {
  columns: _propTypes.PropTypes.array.isRequired,
  height: _propTypes.PropTypes.number.isRequired,
  sortBy: _propTypes.PropTypes.string,
  sortDirection: _propTypes.PropTypes.string,
  minVisibleColumns: _propTypes.PropTypes.number,
  maxVisibleColumns: _propTypes.PropTypes.number,
  onSort: _propTypes.PropTypes.func,
  onScrollRight: _propTypes.PropTypes.func,
  onScrollLeft: _propTypes.PropTypes.func,
  scrolledColumns: _propTypes.PropTypes.number,
  loading: _propTypes.PropTypes.bool,
  style: _propTypes.PropTypes.object,
  className: _propTypes.PropTypes.string
});

_defineProperty(Header, "defaultProps", {
  scrolledColumns: 0,
  loading: false,
  minVisibleColumns: 1,
  style: {},
  className: 'table-header'
});

var _default = Header;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./~/@rapiddot/react-virtual-list/lib/table/header.js
// module id = 476
// module chunks = 0